module.exports = __webpack_public_path__ + "static/media/sim.e66c3032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/sim.jpg
// module id = 161
// module chunks = 0